<template>
  <div>
    <a-card :bordered="false" title="总账">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="起始月份" :labelCol="labelCol" :wrapperCol="wrapperCol"><a-month-picker v-model="beginMoment" format="YYYY-MM" style="width:100%" /></a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="截止月份" :labelCol="labelCol" :wrapperCol="wrapperCol"><a-month-picker v-model="endMoment" format="YYYY-MM" style="width:100%" /></a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol"><store-tenant-select domain="finance" @change="handleStoreTenantChange"></store-tenant-select></a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                <a-checkbox :checked="showQty" style="margin-left: 16px" @change="onQtyToggle">显示数量金额</a-checkbox>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table bordered size="middle" rowKey="key" :columns="columns" :dataSource="dataSource" :pagination="false" :loading="loading" :rowClassName="rowClassName" :scroll="tableScroll" />
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import { ledgerGeneralLedger, accountSetCurrent } from './api'
import StoreTenantSelect from '@/components/StoreTenantSelect'

const fmt2 = v => (v === null || v === undefined || v === '' || isNaN(Number(v))) ? '' : Number(v).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const fmtQ = v => (v === null || v === undefined || v === '') ? '' : String(Number(v))

export default {
  name: 'GeneralLedgerList',
  components: { StoreTenantSelect },
  data() {
    return {
      labelCol: { span: 6 }, wrapperCol: { span: 17, offset: 1 },
      accountSetId: null, beginMoment: null, endMoment: null, loading: false,
      dataSource: [], showQty: false,
      tableScroll: { x: 'max-content', y: 400 }
    }
  },
  computed: {
    columns() {
      const cols = [
        { title: '科目编码', dataIndex: 'code', width: 110 },
        { title: '科目名称', dataIndex: 'name', width: 150 },
        { title: '期间', dataIndex: 'period', width: 100 },
        { title: '摘要', dataIndex: 'summary', width: 100 },
        { title: '借方金额', dataIndex: 'debit', align: 'right', width: 130 },
        { title: '贷方金额', dataIndex: 'credit', align: 'right', width: 130 },
        { title: '方向', dataIndex: 'direction', align: 'center', width: 70 },
        { title: '余额', dataIndex: 'balance', align: 'right', width: 130 }
      ]
      if (this.showQty) {
        cols.splice(6, 0,
          { title: '借方数量', dataIndex: 'debitQty', align: 'right', width: 100 },
          { title: '贷方数量', dataIndex: 'creditQty', align: 'right', width: 100 })
      }
      return cols
    }
  },
  created() {
    this.beginMoment = moment()
    this.endMoment = moment()
    this.loadCurrent()
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$el.querySelector('.ant-table')
      if (el) {
        const top = el.getBoundingClientRect().top
        this.tableScroll.y = Math.max(300, window.innerHeight - top - 24)
      }
    })
  },
  methods: {
    loadCurrent() {
      accountSetCurrent({}).then((res) => {
        if (res && res.success && res.data && res.data.id) { this.accountSetId = res.data.id; this.searchQuery() } else { this.$message.warning('尚未建账') }
      })
    },
    searchQuery() {
      this.loading = true
      const beginPeriod = this.beginMoment ? this.beginMoment.format('YYYY-MM') : null
      const endPeriod = this.endMoment ? this.endMoment.format('YYYY-MM') : null
      ledgerGeneralLedger({ accountSetId: this.accountSetId, beginPeriod: beginPeriod, endPeriod: endPeriod }).then((res) => {
        if (res && res.success) this.dataSource = this.buildRows(res.data || [])
        else if (res && res.message) this.$message.warning(res.message)
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    buildRows(groups) {
      const rows = []
      groups.forEach((g) => {
        const gid = g.subjectId || g.code
        const o = g.opening || {}
        rows.push({ key: gid + '-open', rowType: 'open', code: g.code, name: g.name, period: '', summary: '期初余额',
          debit: '', credit: '', debitQty: '', creditQty: '', direction: o.direction || '平', balance: fmt2(o.balance) })
        ;(g.months || []).forEach((m, i) => {
          rows.push({ key: gid + '-m' + i, rowType: 'month', code: g.code, name: g.name, period: m.yearMonth || '', summary: '本期合计',
            debit: fmt2(m.debit), credit: fmt2(m.credit), debitQty: fmtQ(m.debitQty), creditQty: fmtQ(m.creditQty),
            direction: m.direction || '', balance: fmt2(m.balance) })
        })
        const yt = g.yearTotal || {}
        rows.push({ key: gid + '-total', rowType: 'total', code: g.code, name: g.name, period: '', summary: '本年累计',
          debit: fmt2(yt.debit), credit: fmt2(yt.credit), debitQty: '', creditQty: '', direction: yt.direction || '', balance: fmt2(yt.balance) })
      })
      return rows
    },
    searchReset() { this.beginMoment = moment(); this.endMoment = moment(); this.searchQuery() },
    handleStoreTenantChange() { this.searchQuery() },
    onQtyToggle(e) { this.showQty = e.target.checked },
    rowClassName(record) {
      if (record.rowType === 'open') return 'gl-general-open-row'
      if (record.rowType === 'total') return 'gl-general-total-row'
      return ''
    }
  }
}
</script>

<style scoped>
/deep/ .gl-general-open-row td { background: #fbfbfb !important; }
/deep/ .gl-general-total-row td { background: #fafafa !important; font-weight: 600; }
</style>
